/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

/* eslint-disable no-use-before-define */

import { withStyles } from '@mui/styles';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import * as React from 'react';
import './styles.css';
import classNames from 'classnames';

interface Props {
    title: string,
    listValues: any,
    UpdateSelectedValues: Function,
    disabled: boolean,
    selectedValues: any,
    isSelectOnlyOne: boolean,
    classes?: any
    selectedColors?: any
}
const styles = () => ({

    active: {
        backgroundColor: '#fff !important'
    },
    selectInput: {
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
        transition: '0.3s'
    },
    elevatedInput: {
        zIndex: 100
    },
    inputLabel: {
        fontSize: 14,
        marginLeft: 10
    },
    enabledInputLabel: {
        fontFamily: 'Roboto',
        color: '#000000DE',
    }
})

class DropDownWithCheckBox extends React.Component<Props> {
    state = {
        selectedListValues: [] as any,
    };
    componentDidMount() {
        if (this.props.selectedValues !== undefined) {
            this.setState({ selectedListValues: this.props.selectedValues });
        }
    }
    handleChange = (event: any) => {

        const constvalue: any = event.target.value;
        if (this.props.isSelectOnlyOne) {

            if (this.state.selectedListValues.length > 0) {
                constvalue.splice(0, 1);
            }
        }

        this.setState({ selectedListValues: constvalue }, () => {
            this.props.UpdateSelectedValues(this.state.selectedListValues);
        });
    };
    handleRemoveFilter = (value: any) => () => {
        const a: any = this.state.selectedListValues;
        const index = a.indexOf(value);
        if (index > -1) {
            a.splice(index, 1);
            this.setState({ selectedListValues: a }, () => {
                this.props.UpdateSelectedValues(this.state.selectedListValues);
            });
        }
    };

    MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 300,
                width: 250,
            },
        },
    };
    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (
            prevProps.listValues !== this.props.listValues
        ) {
            const currentListValues = this.props.listValues.map((y: any) => {
                return y.id;
            });
            const a = prevState.selectedListValues.filter((x: any) => {
                return currentListValues.indexOf(x) > -1;
            });
            this.setState({ selectedListValues: a }, () => {
                this.props.UpdateSelectedValues(this.state.selectedListValues);
            });
        }
    }
    render() {
        const { classes, title, listValues, selectedColors } = this.props;
        return (
            <div>
                <div>
                    <FormControl className="dropdownFormControl" disabled={this.props.disabled}>
                        {this.state.selectedListValues.length === 0 &&
                            <InputLabel shrink={false} htmlFor="select-multiple-checkbox" id="select-multiple-checkbox"
                                className={this.props.disabled ? classNames(classes.inputLabel, classes.elevatedInput) :
                                    classNames(classes.inputLabel, classes.elevatedInput, classes.enabledInputLabel)}>
                                {title}
                            </InputLabel>}
                        <Select
                            classes={{ root: classes.selectInput }}
                            id="demo-mutiple-checkbox"
                            multiple
                            value={this.state.selectedListValues}
                            onChange={this.handleChange}
                            input={<Input id="select-multiple-checkbox" />}
                            renderValue={() =>
                                <div className={classes.inputLabel}>{title}</div>
                            }
                            MenuProps={this.MenuProps}
                        >
                            {listValues.map((x: any) => (
                                <MenuItem key={x.id} value={x.id} classes={{ selected: classes.active }}>
                                    <ListItemText primary={x.name} />
                                    <Checkbox color={'primary'} checked={this.state.selectedListValues.indexOf(x.id) > -1} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div className="dropDownChipHolder">
                    {(listValues.filter((x: any) => this.state.selectedListValues.indexOf(x.id) > -1)).map((value: any, index: any) => (
                        <Chip style={{ backgroundColor: selectedColors !== undefined && selectedColors[index] }}
                            className="dropdownChips" key={value.id} label={value.name} onDelete={this.handleRemoveFilter(value.id)} />
                    ))}
                </div>
            </div>
        );
    }
}
export default withStyles(styles)(DropDownWithCheckBox);
